import SkillTesting from './skill-tesing'

// import middlewares
export default [{
  path: '/skill-tesing-questions',
  component: SkillTesting,
  name: 'SkillTesting',
  meta: {
    nav: {
      display: true,
      name: 'Skill Testing Questions',
      icon: 'fas fa-question-circle'
    }
  }
}]
